// extracted by mini-css-extract-plugin
module.exports = {"h100":"SanityNextImg_h100___4Diy","w100":"SanityNextImg_w100__C_pbe"};